/**
 * Intelligently compresses button text by abbreviating common words
 * while keeping brand names, model names, and acronyms intact
 */
export const compressButtonText = (text: string, maxLength: number = 30): string => {
  // If text is already short enough, return as-is
  if (text.length <= maxLength) {
    return text;
  }

  // Common word abbreviations (case-insensitive)
  const abbreviations: Record<string, string> = {
    // French
    'Configurer': 'Config',
    'Configure': 'Config',
    'Construire': 'Const',
    'Personnaliser': 'Perso',
    'Preferred': 'Pref',
    'Préféré': 'Pref',
    'Essential': 'Ess',
    'Essentiel': 'Ess',
    'Ultimate': 'Ult',
    'Limited': 'Ltd',
    'Limitée': 'Ltd',
    'Long Range': 'LR',
    'Longue Autonomie': 'LA',
    'Standard Range': 'SR',
    'Autonomie Standard': 'AS',
    'Extended Range': 'ER',
    'Autonomie Étendue': 'AE',
    'All-Wheel Drive': 'AWD',
    'All Wheel Drive': 'AWD',
    'Quatre Roues Motrices': 'AWD',
    'Four Wheel Drive': '4WD',
    'Front-Wheel Drive': 'FWD',
    'Front Wheel Drive': 'FWD',
    'Traction Avant': 'FWD',
    'Rear-Wheel Drive': 'RWD',
    'Rear Wheel Drive': 'RWD',
    'Propulsion': 'RWD',
  };

  let compressed = text;

  // Apply abbreviations
  Object.entries(abbreviations).forEach(([full, abbr]) => {
    const regex = new RegExp(`\\b${full}\\b`, 'gi');
    compressed = compressed.replace(regex, abbr);
  });

  return compressed;
};
